import gql from 'graphql-tag';

export const Company360FullFragment = gql`
	fragment Company360FullFragment on Company360 {
		id
		localId
		status
		companyLevel
		Company {
			id
			name
		}
		Service {
			id
			name
		}
		FoodService {
			id
			name
		}
		Retailer {
			id
			name
		}
		Brand {
			id
			name
		}
	}
`;